import React, { useContext } from 'react';
import { Outlet } from 'react-router';

import { useCheckNotifications } from '../../../../shared/hooks/notificationHook';

import { CookieBanner } from './Cookie';
import { ExternalPageContext } from './ExternalPageContext';
import { LayoutFooter } from './LayoutFooter';
import { LandingLayoutHeader } from './LayoutHeader';
import { LayoutBackground } from './components';

export const LandingLayout = () => {
  useCheckNotifications();

  const { external } = useContext(ExternalPageContext);

  return (
    <LayoutBackground>
      <LandingLayoutHeader />
      <Outlet />
      {!window.env.FOOTER_DISABLED && <LayoutFooter />}
      {!external && <CookieBanner />}
    </LayoutBackground>
  );
};
